import { h, Fragment } from 'preact';
import style from './style.css';

import { useEffect, useRef, useState } from 'preact/hooks';

import { submit } from './controller';

import Header from '../../../components/header';
import Footer from '../../../components/footer';

import FormValidator from 'simple-form-valid';
import Validator from '../../../scripts/validator';
import getFormData from '../../../scripts/FormData';

import Store from '../../../stores/Store';
import CustomButton from '../../../components/button';
import { GlobalState } from '../../../states/global-state';
import SignupTitle from '../../../components/common/signup-title';
import SignupSubTitle from '../../../components/common/signup-subtitle';
import { showAlert, showSpinner, hideSpinner } from '../../../utils';
import Spinner from '../../../components/spinner';

const RegisterActivate = props => {
  const [formValidation, setFormValidation] = useState(null);
  const [email, setEmail] = useState(null);

  const formRef = useRef<HTMLFormElement>(null);

  const store = new Store();

  useEffect(() => {
    (async () => {
      const email = store.get('email');
      setEmail(email);

      setFormValidation(
        await new FormValidator(formRef.current, Validator, {
          // class of the parent element where the error/success class is added
          parentClass: 'form-group',
          errorClass: 'invalid',
          successClass: 'valid',
          // class of the parent element where error text element is appended
          errorTextParent: 'form-group',
          // type of element to create for the error text
          errorTextTag: 'div',
          // class of the error text element
          errorTextClass: 'invalid-feedback',
        })
      );
    })();
  }, []);

  function resendCodeHandler() {
    //
  }

  async function submitHandler(e) {
    try {
      e.preventDefault();

      const valid = await formValidation.validate('.input');

      if (!valid) {
        return;
      }

      showSpinner();
      const data = getFormData<{
        security_code: string;
      }>(e.target);

      const submitted = await submit(data.security_code);
      hideSpinner();

      // console.log(submitted);
    } catch (err) {
      hideSpinner();
      showAlert({
        title: 'Error',
        icon: 'error',
        text: err.message,
        allowOutsideClick: false,
        showConfirmButton: true,
      });
    }
  }

  return (
    <Fragment>
      <Header />
      <div class="container-xl">
        <br />

        <SignupTitle>Activate Account</SignupTitle>
        <br />
        <SignupSubTitle>
          An activation code has been sent to your e-mail address: {email}{' '}
        </SignupSubTitle>

        <div style={{ maxWidth: '600px', margin: 'auto' }}>
          <form ref={formRef} onSubmit={submitHandler}>
            <div class="form-floating mb-3 form-group">
              <input
                type="text"
                class="form-control input"
                id="security_code"
                name="security_code"
                placeholder="ACTIVATION CODE"
                data-validator="required=true, length=6"
              />
              <label for="security_code">Input your Security Code</label>
            </div>

            <div class="text-left">
              <CustomButton
                type="submit"
                class="btn btn-success"
                isLoading={GlobalState.showSpinner.value}
              >
                Activate
              </CustomButton>
              &nbsp; &nbsp;
              <CustomButton
                type="button"
                onClick={resendCodeHandler}
                class="btn btn-outline-warning"
              >
                Resend Code
              </CustomButton>
            </div>
          </form>
          <Spinner />
        </div>
      </div>

      <div style={{ height: '30vh' }} />

      <Footer />
    </Fragment>
  );
};

interface ResourceProps {
  title: string;
  description: string;
  link: string;
}

const Resource = (props: ResourceProps) => {
  return (
    <a href={props.link} class={style.resource}>
      <h2>{props.title}</h2>
      <p>{props.description}</p>
    </a>
  );
};

export default RegisterActivate;
